import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AttachedFilesService {
  constructor() {}

  downloadPDF() {
    const btn = document.createElement('button');
    btn.classList.add('file-option');
    btn.textContent = 'Visualizar materiais educativos';

    btn.innerHTML = `<img src='../../assets/svg/icons/view.png'><p>${'Visualizar materiais educativos'}</p>`;

    let chat = document.getElementById('chat');
    let optionsDiv = document.createElement('div');
    optionsDiv.classList.add('answer-options-div');
    chat?.appendChild(optionsDiv);
    optionsDiv.appendChild(btn);

    btn.addEventListener('click', () => {
      const link = document.createElement('a');
      link.href = '../../assets/docs/Material de Educação em Saúde, Postura e Autocuidado.pdf';
      link.download = 'Material de Educação em Saúde, Postura e Autocuidado.pdf';
      document.body.appendChild(link);
      link.click();
    });

    return btn;
  }

  sendImageToChat(text: string) {
    const imagePath = `../../assets/images/${text}`;

    const chat = document.getElementById('chat');
    const optionsDiv = document.createElement('div');
    optionsDiv.classList.add('answer-options-div');

    const imgWrapper = document.createElement('div');
    imgWrapper.classList.add('image-message');

    const img = document.createElement('img');
    img.src = imagePath;
    img.alt = text;
    img.classList.add('chat-image');

    chat?.appendChild(optionsDiv);
    optionsDiv.appendChild(imgWrapper);
    imgWrapper.appendChild(img);

    return img;
  }

}
